import type { MetaFunction } from "@remix-run/node";
import { Outlet } from "@remix-run/react";

export const meta: MetaFunction = ({ params }) => {
  if (!params?.enterprise) return [];

  const href = `/api/enterprises/${params.enterprise}/stylesheet.css`;

  return [
  { tagName: "link", rel: "preload", href, as: "style" },
  { tagName: "link", rel: "stylesheet", href }];

};

export default function EnterpriseLayout() {
  return <Outlet />;
}